import styled, { useTheme } from "styled-components";
import { ICONSAX_SIZE } from "../../../Iconsax/Iconsax.types.js";
import { LinkedinOriginal } from "../../../Iconsax/LinkedinOriginal.js";
import { Tooltip } from "../../../Tooltip/Tooltip.component.js";
import { DefaultAvatarProps } from "../../Avatar.types.js";
import { LinkedInIconProps, WithTooltipProps } from "./types.js";

export const StyledLinkedInIcon = styled.div<LinkedInIconProps & Pick<DefaultAvatarProps, "size">>`
    position: absolute;
    top: ${({ size, theme }) => {
        switch (size) {
            case "extraSmall":
                return theme.rem(1);
            case "small":
                return theme.rem(1.25);
            case "medium":
                return theme.rem(2);
            case "large":
                return theme.rem(2.8);
            case "extraLarge":
                return theme.rem(4);
            default:
                return theme.rem(2);
        }
    }};
    left: ${({ size, theme }) => {
        switch (size) {
            case "extraSmall":
                return theme.rem(1);
            case "small":
                return theme.rem(1.125);
            case "medium":
                return theme.rem(2);
            case "large":
                return theme.rem(2.8);
            case "extraLarge":
                return theme.rem(4.2);
            default:
                return theme.rem(2);
        }
    }};
`;

const WithTooltip = ({ tooltip, children }: WithTooltipProps): JSX.Element => {
    if (!tooltip) {
        return children;
    }

    return <Tooltip content={tooltip}>{children}</Tooltip>;
};

export const LinkedInIcon = ({ color, size = "medium", tooltip }: LinkedInIconProps): JSX.Element => {
    const theme = useTheme();

    const getIconColor = (color: LinkedInIconProps["color"]) => {
        switch (color) {
            case "gray":
                return theme.grayscale[70];
            case "blue":
                return theme.colors.brand.linkedin;
            case "orange":
                return theme.colors.warning[100];
            default:
                return theme.grayscale[70];
        }
    };

    const getIconSize = (size: LinkedInIconProps["size"]): typeof ICONSAX_SIZE.SMALL | typeof ICONSAX_SIZE.LARGE | undefined => {
        if (size === undefined) return undefined;
        if (size === "small") return ICONSAX_SIZE.SMALL;
        return ICONSAX_SIZE.LARGE;
    };

    return (
        <WithTooltip tooltip={tooltip}>
            <StyledLinkedInIcon color={color} size={size}>
                <LinkedinOriginal size={getIconSize(size)} color={getIconColor(color)} />
            </StyledLinkedInIcon>
        </WithTooltip>
    );
};
